import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";

// Fixed-order categorical palette (dataviz skill's validated dark-mode set,
// checked against this app's #17171b card surface) - assigned by index, never
// cycled/repainted when the shareholder list changes shape.
const SHAREHOLDER_COLORS = [
  "#3987e5", // blue
  "#199e70", // aqua
  "#c98500", // yellow
  "#008300", // green
  "#9085e9", // violet
  "#e66767", // red
  "#d55181", // magenta
  "#d95926", // orange
];
const NPC_COLOR = "#5b5b63"; // neutral - "Other"/unassigned, deliberately outside the categorical set

const CustomTooltip = ({ active, payload }) => {
  if (!active || !payload?.length) return null;
  const { name, value } = payload[0];
  return (
    <div className="rounded-md border border-white/10 bg-[#0f0f12] px-3 py-2 text-xs text-white/80 shadow-lg">
      {name}: <span className="text-[#F0801F]">{value} %</span>
    </div>
  );
};

// Ownership pie chart: each real shareholder gets a fixed-order categorical
// color; whatever percent isn't assigned to a real character (still
// NPC-held, or simply never sold) folds into a single neutral "NPC /
// nepřidělené" slice rather than inventing more hues.
export const OwnershipPieChart = ({ shareholders, npcOwnerName, unassignedPercent }) => {
  const data = shareholders.map((s, i) => ({
    name: s.character_name,
    value: s.shares,
    color: SHAREHOLDER_COLORS[i % SHAREHOLDER_COLORS.length],
  }));
  if (unassignedPercent > 0) {
    data.push({ name: `NPC „${npcOwnerName}“`, value: unassignedPercent, color: NPC_COLOR });
  }

  return (
    <div>
      <div style={{ width: "100%", height: 220 }}>
        <ResponsiveContainer>
          <PieChart>
            <Pie data={data} dataKey="value" nameKey="name" innerRadius={50} outerRadius={80} paddingAngle={2}>
              {data.map((entry) => (
                <Cell key={entry.name} fill={entry.color} stroke="#17171b" strokeWidth={2} />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>
      <ul className="mt-2 space-y-1.5">
        {data.map((entry) => (
          <li key={entry.name} className="flex items-center justify-between text-sm">
            <span className="flex items-center gap-2 text-white/70">
              <span
                className="inline-block h-2.5 w-2.5 shrink-0 rounded-full"
                style={{ backgroundColor: entry.color }}
              />
              {entry.name}
            </span>
            <span className="text-white/50">{entry.value} %</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
